import {
  createSettingsParams,
  SettingsParamType,
  SettingParamMetadataResolver,
} from '@wix/tpa-settings';
import applicationJson from '../../../.application.json';
import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';

export type ISettingsParams = {
  greetingsText: SettingsParamType.Text;
  anotherThing: SettingsParamType.Boolean;
};

export default createSettingsParams<ISettingsParams>({
  greetingsText: {
    type: SettingsParamType.Text,
    key: 'rejusp-custom-greetingsText',
    dangerousKeyTransformationOverride: (key, { isMobile, language }) =>
      key + isMobile + language,
    getDefaultValue: ({ t }) =>
      `${t(['app.settings.defaults.greetingsPretext'])} ${
        applicationJson.appName
      }`,
    metadata: (({ t }) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('app.settings.defaults.greetingsPretext'),
      },
    })) as SettingParamMetadataResolver,
  },
  anotherThing: {
    type: SettingsParamType.Text,
    getDefaultValue() {
      return false;
    },
    metadata: {
      type: DataType.text,
      defaultValue: { type: 'static', value: 'test' },
    },
  },
});
